/*
 * ****************************************************************
 * File: callCard.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Pavan Kumar
 *
 * ****************************************************************
 */
import React, { useEffect } from "react";
import {
  Typography,
  ListItemSecondaryAction,
  ListItemText,
  ListItem,
  List,
  ListItemAvatar,
  Avatar,
  Paper,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CallMadeIcon from "../../assets/recent_calls/Outgoing_call.svg";
import CallReceivedIcon from "../../assets/recent_calls/Incoming_Call.svg";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import VideoIcon from "../../assets/Video_Icon.svg";
import AudioIcon from "../../assets/Audio_Icon.svg";
import MissedCall from "../../assets/Missed_Call.svg";
import Call_unanswered from "../../assets/Call_unanswered.svg";
import Keyboard from "../../components/Keyboard";
import moment from "moment";

export default function Callcard({
  remoteURI,
  session,
  setRemoteURI,
  makeCall,
  setCallDate,
  // connection,
}) {
  const history = useHistory();
  const [dense] = React.useState(false);
  const [audioCall, setAudioCall] = React.useState(false);
  const [videoCall, setVideoCall] = React.useState(false);
  const inputRef = React.useRef();

  const [Userstate] = React.useState(
    JSON.parse(localStorage.getItem("history"))
  );

  useEffect(() => {
    if (session.session && session.ringing) {
      history.push("/callinprogress");
    } else if (session.session === null) {
      history.push("/home");
    }
  }, [session]);

  useEffect(() => {
    if (inputRef.current && inputRef.current.value !== remoteURI) {
      inputRef.current.value = remoteURI;
    }
  }, [remoteURI]);

  // BreakPoints
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));
  const formatDate=(date)=>{
   return moment(new Date(date)).format("DD/MM/YYYY");
  }
  return (
    <div style={{ margin: "1rem", marginBottom: "1rem" }}>
      <Grid
        container
        item
        xs={12}
        style={{
          marginTop: isMatch ? "14vh" : "18vh",
          width: "100%",
          height: "82vh",
        }}
      >
        <Grid item lg={6} xs={12} justify="center">
          <Paper
            style={{ height: "75vh", overflow: "hidden", margin: "0.1rem" }}
          >
            <div>
              <Typography
                data-testid="text"
                style={{
                  color: "#314B9F",
                  textAlign: "left",
                  float: "left",
                  marginRight: "auto",
                  padding: "10px",
                }}
              >
                Make Call
              </Typography>
            </div>
            <div
              style={{
                textAlign: "center",
                minWidth: "80%",
                overflow: "auto",
                minHeight: "75.2vh",
                flex: 1,
                flexWrap: "nowrap",
                justifyContent: "center",
                margin: "auto",
              }}
            >
              <Keyboard
                inputRef={inputRef}
                setRemoteURI={setRemoteURI}
                remoteURI={remoteURI}
                session={session}
                makeCall={makeCall}
                audioCall={audioCall}
                videoCall={videoCall}
                setAudioCall={setAudioCall}
                setVideoCall={setVideoCall}
                setCallDate={setCallDate}
              />
            </div>
          </Paper>
        </Grid>
        <Grid
          item
          lg={6}
          xs={12}
          justify="center"
          style={{ marginBottom: "1rem" }}
        >
          <Paper
            style={{
              height: "75vh",
              overflow: "auto",
              margin: "0.1rem",
              marginBottom: "1rem",
            }}
          >
            <div>
              <Typography
                style={{
                  color: "#314B9F",
                  textAlign: "left",
                  float: "left",
                  marginRight: "auto",
                  padding: "10px",
                }}
              >
                Recent Calls
              </Typography>
            </div>
            <div
              style={{
                flex: 1,
                flexWrap: "nowrap",
                justifyContent: "center",
                margin: "auto",
              }}
            >
              <List dense={dense} style={{ marginTop: "5vh", padding: "5px" }}>
                {Userstate?.Calllogs ? (
                  Object.keys(Userstate["Calllogs"])
                    .reverse()
                    .map((singleDate) => {
                      let today = new Date();
                      let yesterday = new Date();
                      yesterday.setDate(today.getDate() - 1);
                      let todayDate = new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }).format(today);
                      let yesterdayDate = new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }).format(yesterday);

                      return (
                        <>
                          <p
                            style={{
                              margin: "1.5rem",
                              color: "#5C5B5B",
                              fontWeight: "bold",
                              fontSize: 14,
                            }}
                          >
                            {singleDate === todayDate
                              ? "Today"
                              : singleDate === yesterdayDate
                              ? "Yesterday"
                              : formatDate(singleDate)}
                          </p>

                          {Userstate["Calllogs"][singleDate]
                            .slice(0)
                            .reverse()
                            .map((item, i) => {
                              return (
                                <>
                                  <ListItem key={i}>
                                    <ListItemAvatar>
                                      <Avatar
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                          background:
                                            item.type === "outgoing"
                                              ? "#01AD24"
                                              : item.type === "incoming"
                                              ? "#01AD24"
                                              : item.type === "missedCall"
                                              ? "#E30000"
                                              : "#C9C9C9",
                                        }}
                                      >
                                        {item.call?.video === false ? (
                                          <img src={AudioIcon} />
                                        ) : (
                                          <img
                                            style={{
                                              width: "25px",
                                              height: "25px",
                                            }}
                                            src={VideoIcon}
                                          />
                                        )}
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Typography
                                          style={{
                                            fontSize: "16px",
                                            color: "#5C5B5B",
                                          }}
                                        >
                                          {item["name"] === null
                                            ? "New user"
                                            : item["name"]}
                                        </Typography>
                                      }
                                      secondary={
                                        <Typography
                                          onClick={() => {
                                            navigator.clipboard.writeText(
                                              item["uri"]
                                            );
                                            setRemoteURI(item["uri"]);
                                          }}
                                          style={{
                                            fontSize: "12px",
                                            color: "#5C5B5B",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {item.type === "outgoing" ? (
                                            <img
                                              style={{
                                                color: "green",
                                                marginRight: "5px",
                                              }}
                                              src={CallMadeIcon}
                                            />
                                          ) : item.type === "incoming" ? (
                                            <img
                                              style={{
                                                color: "green",
                                                marginRight: "5px",
                                              }}
                                              src={CallReceivedIcon}
                                            />
                                          ) : item.type === "missedCall" ? (
                                            <img
                                              style={{
                                                color: "green",
                                                marginRight: "5px",
                                              }}
                                              src={MissedCall}
                                            />
                                          ) : (
                                            <img
                                              style={{
                                                color: "green",
                                                marginRight: "5px",
                                              }}
                                              src={Call_unanswered}
                                            />
                                          )}

                                          {item["uri"]}
                                        </Typography>
                                      }
                                    />
                                    <ListItemSecondaryAction>
                                      <p>{item["duration"]}</p>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                </>
                              );
                            })}
                        </>
                      );
                    })
                ) : (
                  <p
                    style={{
                      textTransform: "capitalize",
                      color: "#5C5B5B",
                      fontSize: "18px",
                      textAlign: "center",
                      marginTop: "30vh",
                    }}
                  >
                    no Call Records
                  </p>
                )}
              </List>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

Callcard.propTypes = {
  remoteURI: PropTypes.string.isRequired,
  setRemoteURI: PropTypes.func.isRequired,
  session: PropTypes.any,
  makeCall: PropTypes.any,
  acceptCall: PropTypes.any,
  debugLogs: PropTypes.any,
//  connectionStatusColor: PropTypes.object.isRequired,
  connection: PropTypes.object.isRequired,
  setCallDate:PropTypes.any
};
